export const AUTH_NAVBAR_MENU_TRIGGER_CLASSES = "size-9 shrink-0 cursor-pointer";

export const AUTH_SIDEBAR_HEADER_MENU_TRIGGER_CLASSES =
  "size-9 shrink-0 cursor-pointer rounded-full";

export const AUTH_SIDEBAR_FOOTER_MENU_TRIGGER_CLASSES =
  "h-auto w-full cursor-pointer justify-start gap-3 px-2 py-2.5";

export const AUTH_SIDEBAR_FOOTER_NAME_CLASSES =
  "block truncate text-sm/4 font-medium text-sidebar-foreground";

export const AUTH_SIDEBAR_FOOTER_SUBTITLE_CLASSES =
  "block truncate text-xs/4 font-normal text-muted-foreground";
